export const getEventIdWithoutTimestamp = (eventId) => {
  const splitTerms = eventId.split('_')
  const id = splitTerms.slice(0, splitTerms.length - 1).join('')
  return id
}

export const isValidHttpUrl = (string) => {
  let url
  
  try {
    url = new URL(string)
  } catch (_) {
    return false
  }

  return url.protocol === 'http:' || url.protocol === 'https:'
}